import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function BlogCard({ post }) {
  const date = new Date(post.published_at).toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
  return (
    <Link
      to={`/news/${post.slug}`}
      data-testid={`blog-card-${post.slug}`}
      className="group flex flex-col overflow-hidden rounded-2xl bg-axe-surface border border-axe-border hover:border-axe-purple/60 transition-all duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[16/10] overflow-hidden">
        <img
          src={post.image}
          alt={post.title}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-4 top-4 px-3 py-1 rounded-full text-[10px] uppercase tracking-[0.25em] font-bold bg-axe-tangerine text-black">
          {post.tag}
        </span>
      </div>
      <div className="p-6 flex flex-col flex-1">
        <div className="text-xs uppercase tracking-[0.3em] text-axe-purple font-semibold">
          {date}
        </div>
        <h3 className="mt-3 font-display font-bold text-xl text-white leading-tight">
          {post.title}
        </h3>
        <p className="mt-3 text-sm text-neutral-400 leading-relaxed flex-1 line-clamp-3">
          {post.excerpt}
        </p>
        <div className="mt-5 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-white group-hover:text-axe-tangerine transition-colors">
          Read more <ArrowUpRight size={14} />
        </div>
      </div>
    </Link>
  );
}
